import type { AppConfig } from "../../types/appConfig";
import { assertResponseOk, expectStatuses, fetchZekay } from "../zekay/httpClient";
import type {
  InitiatePairingRequest,
  MobileDevice,
  MobilePairingInitiation,
} from "./MobileDevice.typed";

export class MobileDeviceModel {
  zekayAPI: string;

  constructor(config: AppConfig) {
    this.zekayAPI = config.zekayAPI;
  }

  async initiatePairing(payload?: InitiatePairingRequest): Promise<MobilePairingInitiation> {
    const r = await fetchZekay(`${this.zekayAPI}/mobile/devices/pairings`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload ?? {}),
    });

    await expectStatuses(r, 201);

    return (await r.json()) as MobilePairingInitiation;
  }

  async restartPairing(deviceId: number): Promise<MobilePairingInitiation> {
    const r = await fetchZekay(`${this.zekayAPI}/mobile/devices/${deviceId}/pairings`, {
      method: "POST",
    });

    await expectStatuses(r, 201);

    return (await r.json()) as MobilePairingInitiation;
  }

  async listDevices(): Promise<MobileDevice[]> {
    const r = await fetchZekay(`${this.zekayAPI}/mobile/devices`);

    await expectStatuses(r, 200, 204);

    if (r.status === 204) return [];

    const data = (await r.json()) as MobileDevice[] | null;

    return data ?? [];
  }

  async deleteDevice(id: number): Promise<void> {
    const r = await fetchZekay(`${this.zekayAPI}/mobile/devices/${id}`, {
      method: "DELETE",
    });

    await expectStatuses(r, 204);
  }
}

export type { MobileDevice, MobilePairingInitiation };
export { assertResponseOk };
